import localforage from 'localforage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SelectedTerminalStore {
    selectedTerminalId: string | null;
    setSelectedTerminalId: (id: string) => void;
}

export const useSelectedTerminalStore = create(
    persist<SelectedTerminalStore>(
        (set) => ({
            selectedTerminalId: null,
            setSelectedTerminalId: (id) => set({ selectedTerminalId: id }),
        }),
        {
            name: 'selected-terminal',
            storage: createJSONStorage(() => localforage),
        },
    ),
);
